import { Check, Error, LoopOutlined, Schedule, StopCircle } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { WorkFlowStatus } from 'gql/index';
import { useIntl } from 'react-intl';
import { WorkflowStatusType, WorkflowStatusTypeColor } from './types';

export const WorkflowStatusIcon: Record<WorkFlowStatus, React.ReactElement> = {
  [WorkFlowStatus.NotStarted]: <Schedule color='inherit' />,
  [WorkFlowStatus.Completed]: <Check color='inherit' />,
  [WorkFlowStatus.InProgress]: <LoopOutlined color='inherit' />,
  [WorkFlowStatus.Stopped]: <StopCircle color='inherit' />,
  [WorkFlowStatus.Error]: <Error color='inherit' />,
};

export const WorkflowStatusChip = (props: { status: WorkFlowStatus }) => {
  const { formatMessage } = useIntl();
  return <Chip label={formatMessage(WorkflowStatusType[props.status])}
    icon={WorkflowStatusIcon[props.status]}
    color={WorkflowStatusTypeColor[props.status]}
    sx={{
      color: 'inherit',
    }}
    size='small' />;
};